import React from 'react';
import BaseClass from '@/pages/BaseClass';
import {
	HashRouter,
	BrowserRouter as Router,
	Route,
	IndexRoute,
	Switch,
} from 'react-router-dom';
import {
	Form,
	Button,
	Input,
	Checkbox,
} from 'antd'

import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';
import Login from './scan/Login';
import Index from './scan/Index';
import Photo from './scan/Photo';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'headScope':{
				'title':'',
				'leftButton':null,
				'rightButton':null,
			},
		};
		
		global.setScanState=this.setScanState.bind(this);
	}
	
	componentDidMount()
	{
		global.setRootState({
			'hideLayout':true,
		});
		this.getSiteList();
	}
	
	setScanState(data)
	{
		return new Promise((resolve,reject)=>{
			for(let i in data)
			{
				if(this.state[i] === undefined)
					delete(data[i]);
				else
				{
					this.state[i] = data[i];
				}
			}
			
			this.setState(data,resolve);
		});
	}
	
	initHead({title,leftButton,rightButton})
	{
		this.setState({
			'title':title,
			'leftButton':leftButton,
			'rightButton':rightButton,
		});
	}
	
	getSiteList()
	{
		console.log('getSiteList');
		let url = pcUrl('index','siteList');
		httpPost(url);
		return;
		/*
			.then(data=>{
				
			});
		*/
	}
	
	render()
	{
		return (
		<>
			<div className="m-head">
				<div className="m-left">
					{this.state.headScope.leftButton}
				</div>
				<h1>{this.state.headScope.title}</h1>
				<div className="m-right">
					{this.state.headScope.rightButton}
				</div>
			</div>
			<Switch>
				<Route exact path="/scan" component={Login} />
				<Route path="/scan/login" component={Login} />
				<Route path="/scan/index" component={Index} />
				<Route path="/scan/photo/:id" component={Photo} />
			</Switch>
		</>
		);
	}
}
